export default {
  path: '/reports',
  component: {
    render: h => h('router-view'),
  },
  children: [
    {
      path: '/reports/lenovo-reports',
      component: () => import('./lenovo-reports'),
    },
    {
      path: '/reports/css-reports',
      component: () => import('./css-reports'),
    },
    {
      path: '/reports/ludp-reports',
      component: () => import('./ludp-reports'),
    },
    {
      path: '/reports/country-risk-analysis-report',
      component: () => import('./country-risk-analysis-report'),
    },
    {
      path: '/reports/country-risk-analysis-report/detail',
      component: () => import('./country-risk-analysis-report/detail'),
    },
  ],
}
